import { render, staticRenderFns } from "./BarGroup.vue?vue&type=template&id=b8b747ca"
import script from "./BarGroup.vue?vue&type=script&lang=js"
export * from "./BarGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./BarGroup.scss?vue&type=custom&index=0&blockType=styles&issuerPath=%2Fapp%2Fsrc%2Fpages%2FBarGroup%2FBarGroup.vue&lang=scss&external"
if (typeof block0 === 'function') block0(component)

export default component.exports